import React, { Fragment } from 'react'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs'
import { DashboardTitle, ECommerceTitle, EcommerceDashboardTitle } from '../../../Utils/Constants'
import { Container, Row } from 'reactstrap'
import ProgressItemCards from './ProgressItemCards'
import FeedbackCard from './FeedbackCard'
import ProductOrder from './ProductOrder'
import NewOrder from './NewOrder'
import UserActivity from './UserActivity'
import Invoices from './Invoices'
import RecentStatistics from './RecentStatistics'
import NotificationsCard from './NotificationsCard'
import SaleTopCountries from './SaleTopCountries'
import ReviewSlider from './ReviewSlider'
import SalesReport from './SalesReport'

export default function EcommerceDashboard() {
    return (
        <Fragment>
            <Breadcrumbs pageTitle={EcommerceDashboardTitle} parent={DashboardTitle} title={ECommerceTitle} />
            <Container className="ecommerce-dashboard" fluid>
                <Row>
                    <ProgressItemCards />
                    <FeedbackCard />
                    <ProductOrder />
                    <NewOrder />
                    <UserActivity />
                    <Invoices />
                    <RecentStatistics/>
                    <NotificationsCard/>
                    <SaleTopCountries/>
                    <ReviewSlider/>
                    <SalesReport/>
                </Row>
            </Container>
        </Fragment>
    )
}